import { Component } from "react";
import { Icon } from "../../../icons/Icon";

interface Props {
  isHalfThePrice: boolean;
  positionRight?: boolean; // New prop to determine if indicator should be on the right side
}

class HalfThePriceIndicator extends Component<Props, {}> {
  render() {
    const halfThePrice = "1/2";
    const { isHalfThePrice, positionRight } = this.props;
    // console.log('HalfThePriceIndicator render:', isHalfThePrice, typeof isHalfThePrice, 'positionRight:', positionRight);
    
    // Force boolean conversion
    const shouldShow = Boolean(isHalfThePrice);
    // console.log('HalfThePriceIndicator shouldShow:', shouldShow);
    
    // Determine styling based on position
    const containerStyle = positionRight ? {
      // Right side styling with reversed border radius
      width: "40px",
      height: "40px",
      paddingRight: "10px", // Padding on right instead of left
      paddingTop: "8px",
      borderRadius: "0 8px 0 80%", // Reversed border radius
      textAlign: "right" as const, // Need to specify as const for TypeScript
    } : {
      // Default left side styling
      width: "40px",
      height: "40px",
      paddingLeft: "8px",
      paddingTop: "8px",
      borderRadius: "8px 0 80% 0", // Original border radius
    };
    
    return (
      <div
        className={shouldShow ? "u-background--magenta" : ""}
        style={containerStyle}
      >
        {shouldShow ? (
          <span className="u-color-white u-main-font--14--small u-bold-black">
            {halfThePrice}
          </span>
        ) : null}
      </div>
    );
  }
}

export default HalfThePriceIndicator;
